import { State, ProductSectionState } from '@/pages/categories/types'
import { ParentCategoryType, SectionProductsType } from '@/types'
import { data } from './config/selectors'
import { getJsonData } from '@/utils/dom'

import { SYSTEM_ERROR, LOADSTATUS } from '@/constants'
import { apolloClient } from '@/service/apolloClient'
import { getCategoryDetailAndProduct } from '@/pages/categories/types/getCategoryDetailAndProduct'
import { categoryQuery, facetCategoryQuery } from './queries'
import { getCategoryFacets as GetCategoryFacets } from '@/pages/categories/types/getCategoryFacets'

export interface Store {
  state: State
  getSidebarData: () => void
  fetchCategoryData: () => void
  setCategoryId: (id: number) => void
  getCategoryById: any,
  queryCategoryFacet: any,
  fetchCategoryFacet: (id: number[]) => any
}

export const store: Store = {
  state: {
    categoryId: null,
    loadStatus: LOADSTATUS.NONE,
    heroImage: {
      mainImage: '',
      mainImageAlt: ''
    },
    banners: [],
    detail: null,
    childCategoriesSection: null,
    basicInformation: null,
    productSections: {},
    sidebar: {
      rootCategory: null,
      parentCategory: null,
      childCategories: null,
      siblingCategories: null,
      productCategories: null,
      shortestShippingDates: null
    },
    facetData: []
  },
  getSidebarData() {
    const sidebarData = {
      rootCategory: getJsonData(data.rootCategory),
      parentCategory: getJsonData(data.parentCategory),
      childCategories: getJsonData(data.childCategories),
      siblingCategories: getJsonData(data.siblingCategories),
      productCategories: getJsonData(data.productCategories),
      shortestShippingDates: getJsonData(data.shortestShippingDates)
    }
    this.state = {
      ...this.state,
      sidebar: sidebarData
    }
  },
  setCategoryId(id: number) {
    this.state.categoryId = id
  },
  getCategoryById() {
    return apolloClient
      .query<getCategoryDetailAndProduct>({
        query: categoryQuery,
        variables: {
          id: this.state.categoryId
        }
      })
  },
  async fetchCategoryData() {
    const result = await this.getCategoryById().catch((error: any) => {
      this.state.loadStatus = LOADSTATUS.ERROR
      throw new Error(error)
    })
    const category: ParentCategoryType = result.data.category

    const {
      mainImage,
      mainImageAlt,
      detail,
      categoryBanners,
      childCategories,
      categorySections,
      ...basicInformation
    } = category

    // 子カテゴリーと商品のsectionが混ざってくるので振り分ける
    const childCategorySections = categorySections.filter(
      item => item.sectionType === 'child_category'
    )

    const productSections = categorySections.filter(
      item => item.sectionType !== 'child_category'
    )

    const childCategoriesSectionState = !childCategorySections.length
      ? null
      : {
          ...childCategorySections[0],
          categoryItems: childCategories
        }

    const productSectionState = productSections.reduce<ProductSectionState>(
      (acc, cur) => {
        const key = cur.sectionType!
        const productTags: SectionProductsType[] = cur.tags as SectionProductsType[]
        acc[key] = {
          title: cur.title,
          iconImage: cur.iconImage,
          sectionType: cur.sectionType,
          id: cur.id,
          loadStatus: LOADSTATUS.NONE,
          sectionProducts: productTags
        }
        return acc
      },
      {}
    )

    this.state = {
      ...this.state,
      loadStatus: LOADSTATUS.LOADED,
      heroImage: {
        mainImage: mainImage,
        mainImageAlt: mainImageAlt
      },
      banners: !categoryBanners ? [] : categoryBanners,
      detail: {
        markdown: detail || ''
      },
      childCategoriesSection: childCategoriesSectionState,
      productSections: productSectionState,
      basicInformation
    }
  },
  queryCategoryFacet(categoryIds: number[]) {
    return apolloClient.query<GetCategoryFacets>({
      query: facetCategoryQuery,
      variables: {
        categoryIds: categoryIds,
        offset: 0,
        limit: 0,
        categoryFacets: true
      },
      fetchPolicy: 'no-cache'
    })
  },
  async fetchCategoryFacet(categoryIds: number[]) {
    const result = await this.queryCategoryFacet(
      categoryIds
      ).catch(() => {
      alert(SYSTEM_ERROR.UNKNOWN)
    })
    if (result?.data) {
      this.state.facetData = result.data?.productSearchResults?.facets
    }
  }
}
